import { Decorative } from "@faire/design-tokens";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";

import { SDUIComponentInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";

import { SDUIButtonRenderer } from "../Button/SDUIButtonRenderer";
import { SDUIRichTextRenderer } from "../RichText/SDUIRichTextRenderer";

import { siteBannerWrapper } from "./__internal__/styles/SDUISiteBannerRenderer.css";

export const SDUISiteBannerRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const siteBannerComponent = component.site_banner_component;

  if (!siteBannerComponent) {
    return null;
  }

  const { description } = siteBannerComponent;
  const mobileValue = description?.mobile_and_above;
  const tabletValue = description?.tablet_and_above ?? mobileValue;
  const desktopAndAboveValue = description?.desktop_and_above ?? tabletValue;

  return (
    <div
      className={siteBannerWrapper}
      style={{
        backgroundColor: Decorative.tint.neutral,
      }}
      data-test-id="site-banner-renderer"
    >
      <div>
        <ResponsiveContentV2
          noJS
          mobile={<SDUIRichTextRenderer richTextElement={mobileValue} />}
          tablet={<SDUIRichTextRenderer richTextElement={tabletValue} />}
          desktopAndAbove={
            <SDUIRichTextRenderer richTextElement={desktopAndAboveValue} />
          }
        />{" "}
        {siteBannerComponent.button ? (
          <SDUIButtonRenderer
            buttonElement={siteBannerComponent.button}
            loggingData={loggingData}
          />
        ) : null}
      </div>
    </div>
  );
};
